/**
 * 2가지 색 이상울 가지는 svg 이미지를 사용할 요량으로 제작되었으나, 현재는 용처가 불분명합니다.
 *
 * 이 컴포넌트와 atoms/Icon 컴포넌트와의 관계 정리가 필요하며, 우선 cell에 없는 새 icon을 추가할 때에는 /components/atomic/atoms/CheetahIcon에 추가해주세요.
 */
export enum IllustPack {
  BLIND = 'BLIND',
  CHART = 'CHART',
  CHART_GRAYSCALE = 'CHART_GRAYSCALE',
  EMPTYSTATE = 'EMPTYSTATE',
  ERROR = 'ERROR',
  KNIFE = 'KNIFE',
  LASER = 'LASER',
  MEDICINEBOTTLE = 'MEDICINEBOTTLE',
  MEMO = 'MEMO',
  NOTICE = 'NOTICE',
  NOTIFICATION = 'NOTIFICATION',
  PILL_1 = 'PILL_1',
  PILL_2 = 'PILL_2',
  PRESSSUIT_BOTTOM = 'PRESSSUIT_BOTTOM',
  PRESSSUIT_TOP = 'PRESSSUIT_TOP',
  PRESSSUIT = 'PRESSSUIT',
  SCAR = 'SCAR',
  SENDMAIL = 'SENDMAIL',
  SHOT = 'SHOT',
  STAR = 'STAR',
  STETHOSCOPE = 'STETHOSCOPE',
  SURGICALGLOVES = 'SURGICALGLOVES',
  TELEPHONE = 'TELEPHONE',
  THUMBSUP = 'THUMBSUP',
  SAD_PUMPKIN = 'SAD_PUMPKIN',
  MAGNIFYING_GLASS_DOCUMENT = 'MAGNIFYING_GLASS_DOCUMENT',
}
